/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Gift = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M16.5532 1C18.1225 1 19.4054 2.22679 19.495 3.77369L19.5 3.98404C19.5 5.52887 18.2477 6.78121 16.7028 6.78121L13.4705 6.78295C15.1242 8.62915 16.9627 9.53121 19 9.53121V11.0312C16.6712 11.0312 14.5836 10.0773 12.7492 8.20466L12.749 21.531L21.5 21.5312V7.53121L19.1279 7.53204C19.6895 7.14742 20.1552 6.63292 20.4816 6.03183L23 6.03121V23.0312H1V6.03121L3.51837 6.03183C3.84481 6.63292 4.31048 7.14742 4.87211 7.53204L2.5 7.53121V21.5312L11.249 21.531L11.2499 8.20568C9.4156 10.0776 7.3284 11.0312 5 11.0312V9.53121C7.03733 9.53121 8.87581 8.62915 10.5295 6.78295L7.29717 6.78121C5.80955 6.78121 4.59317 5.61992 4.50511 4.15444L4.5 3.94684C4.5 2.31935 5.81933 1 7.44683 1C8.19695 1 8.91884 1.28606 9.46535 1.79988C10.3151 2.59876 11.1593 3.5741 11.9996 4.72583C12.8407 3.5741 13.6849 2.59876 14.5347 1.79988C15.0812 1.28606 15.8031 1 16.5532 1ZM16.5532 2.5L16.3964 2.50852L16.2426 2.53373C15.9894 2.58939 15.7538 2.71253 15.5621 2.89273L15.27 3.17527C14.7828 3.65975 14.2935 4.21214 13.8025 4.83245L13.457 5.28038L16.7028 5.28121C17.3745 5.28121 17.9269 4.77077 17.9933 4.11667L18 3.94683C18 3.14777 17.3522 2.5 16.5532 2.5ZM7.44683 2.5C6.69477 2.5 6.07673 3.0738 6.00662 3.80749L6 3.98404C6 4.70045 6.58076 5.28121 7.29717 5.28121L10.543 5.28038L10.4923 5.21279C9.90235 4.43581 9.31469 3.75665 8.72998 3.17527L8.43788 2.89273C8.24622 2.71253 8.01062 2.58939 7.75743 2.53373L7.60361 2.50852L7.44683 2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
